import React, { FC, memo, useEffect } from "react";
import classes from "./DisplayArea.module.scss";
import { WorkerForMatrix } from "../../../types/dirary";
import Results from "../organizms/Results";

const DisplayArea: FC = memo(() => {
  return (
    <div className={classes.rootContainer}>
      <Results />
    </div>
  );
});
export default DisplayArea;
